// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3ZYiY","large":"styles_large__O0KkB"};